module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/banner/zh-hans-4a27195a9bd9a7f9e7a0b1fb516279b1.jpg";